<form [formGroup]="form" (ngSubmit)="submit()" class="space-y-4">
  <div>

    <h3>Carga de usuarios por plantilla</h3>

    <label class="block font-semibold mb-2">Adjunta el archivo Excel (.xlsx / .xls) con las columnas requeridas:
    </label>

    <div class="row">
      <p>Descargar plantilla:</p>
      <div class="col-md-12">
        <a href="assets/plantillas/plantilla_usuarios.xlsx" download="plantilla-usuarios.xlsx" class="btn btn-success">
          <i class="fa fa-download"></i>
        </a>
      </div>
    </div>


    <div class="row mt-4">
      <input type="file" accept=".xls,.xlsx" (change)="onFileChange($event)" class="form-control" />
    </div>


    <div class="text-sm text-red-600 mt-1" *ngIf="f.file.touched && f.file.errors">
      <span *ngIf="f.file.errors['required']">El archivo es obligatorio.</span>
      <span *ngIf="f.file.errors['extension']">Solo se permiten archivos .xls o .xlsx.</span>
      <span *ngIf="f.file.errors['maxSize']">El tamaño máximo es de 10 MB.</span>
    </div>
  </div>

  <br />
  <br />

  <button type="submit" [disabled]="form.invalid || uploading" class="btn btn-primary">
    <i class="fa fa-upload"></i>

    {{ uploading ? 'Subiendo...' : 'Importar usuarios' }}
  </button>

  <div *ngIf="uploading" class="mt-2 text-sm text-gray-600">
    Procesando...
  </div>
</form>

<!-- Resultado -->
<div *ngIf="result" class="mt-6">

  <br /><br /><br />
  <h5 class="font-semibold mb-2">Resultado de la importación</h5>

  <table class="table table-striped table-hover" style="width: 100%;" *ngIf="this.result">
    <caption class="visually-hidden">
        Importe de usuarios
    </caption>
    <thead>
      <th scope="col" class="text-center">Resultado</th>
      <th scope="col" class="text-center">Cantidad</th>
    </thead>
    <tbody>

      <tr>
        <td>
          <p style="
            width: 8em !important;
            height: 1.8em;
            background-color: green;
            color: white;
            border-radius: 25px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto;
          " class="text-center">
            Procesados
          </p>
        </td>
        <td class="text-center">
          {{this.result?.processed}}
        </td>
      </tr>

      <tr>
        <td>
          <p style="
            width: 8em !important;
            height: 1.8em;
            background-color: #63b3db;
            color: white;
            border-radius: 25px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto;
          " class="text-center">
            Ingresados
          </p>
        </td>
        <td class="text-center">
          {{this.result?.inserted}}
        </td>
      </tr>

      <tr>
        <td>
          <p style="
            width: 8em !important;
            height: 1.8em;
            background-color: #db6363;
            color: white;
            border-radius: 25px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto;
          " class="text-center">
            Errores
          </p>
        </td>
        <td class="text-center">
          {{this.result?.errorsCount}}
        </td>
      </tr>

    </tbody>
  </table>
</div>